import { LocationScope, LocationVarKey, APIScope } from "@swivl-mono/types";

import { RouterWorksheetData } from "../../Components/Worksheets/Types/Worksheet.Interface";
import AccountBalance from "./Pages/Cortex.AccountBalance";
import AccountNumber from "./Pages/Cortex.AccountNumber";
import AccountStatus from "./Pages/Cortex.AccountStatus";
import AccountBillingDispute from "./Pages/Cortex.AccountBillingDispute";
import AdminFee from "./Pages/Cortex.AdminFee";
import AfterHourAccess from "./Pages/Cortex.AfterHourAccess";
import AgentQuickReply from "./Pages/Cortex.AgentQuickReply";
import Auction from "./Pages/Cortex.Auction";
import AutoPay from "./Pages/Cortex.AutoPay";
import BillingDispute from "./Pages/Cortex.BillingDispute";
import BoatStorage from "./Pages/Cortex.BoatStorage";
import CTAMessage from "./Pages/Cortex.CTAMessage";
import CancelService from "./Pages/Cortex.CancelService";
import Cancellation from "./Pages/Cortex.Cancellation";
import Careers from "./Pages/Cortex.Careers";
import ChangeDueDate from "./Pages/Cortex.ChangeDueDate";
import Claim from "./Pages/Cortex.Claim";
import ClimateControl from "./Pages/Cortex.ClimateControl";
import ContractLengths from "./Pages/Cortex.ContractLengths";
import Covid from "./Pages/Cortex.Covid";
import CreateLogin from "./Pages/Cortex.CreateLogin";
import CreditCardFee from "./Pages/Cortex.CreditCardFee";
import CronReviewSolicitations from "./Pages/Cortex.CronReviewSolicitations";
import CutLocks from "./Pages/Cortex.CutLocks";
import DamagedItems from "./Pages/Cortex.DamagedItems";
import Discounts from "./Pages/Cortex.Discounts";
import Dollies from "./Pages/Cortex.Dollies";
import DriveUp from "./Pages/Cortex.DriveUp";
import Emergency from "./Pages/Cortex.Emergency";
import EscalationSettings from "./Pages/Cortex.EscalationSettings";
import FacilityAccess from "./Pages/Cortex.FacilityAccess";
import ForgotUsername from "./Pages/Cortex.ForgotUsername";
import Franchise from "./Pages/Cortex.Franchise";
import GateCode from "./Pages/Cortex.GateCode";
import GetLease from "./Pages/Cortex.GetLease";
import GetOut from "./Pages/Cortex.GetOut";
import GetStarted from "./Pages/Cortex.GetStarted";
import GracePeriod from "./Pages/Cortex.GracePeriod";
import HoldUnit from "./Pages/Cortex.HoldUnit";
import Identification from "./Pages/Cortex.Identification";
import Insurance from "./Pages/Cortex.Insurance";
import InsuranceCost from "./Pages/Cortex.InsuranceCost";
import KeyAccess from "./Pages/Cortex.KeyAccess";
import Assistantllm from "./Pages/Cortex.LLMSettings";
import Assistantllmprompts from "./Pages/Cortex.LLMPrompts";
import LateFee from "./Pages/Cortex.LateFee";
import LeadSettings from "./Pages/Cortex.LeadSettings";
import Lights from "./Pages/Cortex.Lights";
import LiveInUnit from "./Pages/Cortex.LiveInUnit";
import LostKey from "./Pages/Cortex.LostKey";
import MaintenancePest from "./Pages/Cortex.MaintenancePest";
import ManageInsurance from "./Pages/Cortex.ManageInsurance";
import MonthlyPayments from "./Pages/Cortex.MonthlyPayments";
import MoveOutPolicy from "./Pages/Cortex.MoveOutPolicy";
import MovingServices from "./Pages/Cortex.MovingServices";
import MovingTruck from "./Pages/Cortex.MovingTruck";
import MultipleAccounts from "./Pages/Cortex.MultipleAccounts";
import OutdoorParking from "./Pages/Cortex.OutdoorParking";
import Overlock from "./Pages/Cortex.Overlock";
import PackingSupplies from "./Pages/Cortex.PackingSupplies";
import PadlockAccess from "./Pages/Cortex.PadlockAccess";
import PartialPayment from "./Pages/Cortex.PartialPayment";
import PastDue from "./Pages/Cortex.PastDue";
import PayBill from "./Pages/Cortex.PayBill";
import PayOnline from "./Pages/Cortex.PayOnline";
import PaymentExtension from "./Pages/Cortex.PaymentExtension";
import PaymentHistory from "./Pages/Cortex.PaymentHistory";
import PaymentIssue from "./Pages/Cortex.PaymentIssue";
import PaymentOptions from "./Pages/Cortex.PaymentOptions";
import Pricing from "./Pages/Cortex.Pricing";
import ProfileCancel from "./Pages/Cortex.ProfileCancel";
import ProfileEscalationBot from "./Pages/Cortex.ProfileEscalationBot";
import ProfileEscalationCustomer from "./Pages/Cortex.ProfileEscalationCustomer";
import ProfileShopping from "./Pages/Cortex.ProfileShopping";
import ProfileWaitlist from "./Pages/Cortex.ProfileWaitlist";
import ProfileWelcome from "./Pages/Cortex.ProfileWelcome";
import ProfileWelcomeBack from "./Pages/Cortex.ProfileWelcomeBack";
import ProfileWhatElse from "./Pages/Cortex.ProfileWhatElse";
import Prorate from "./Pages/Cortex.Prorate";
import RVParking from "./Pages/Cortex.RVParking";
import RVParkingCovered from "./Pages/Cortex.RVParkingCovered";
import RVParkingEnclosed from "./Pages/Cortex.RVParkingEnclosed";
import RateIncrease from "./Pages/Cortex.RateIncrease";
import Referral from "./Pages/Cortex.Referral";
import Refunds from "./Pages/Cortex.Refunds";
import Reservation from "./Pages/Cortex.Reservation";
import ResetPassword from "./Pages/Cortex.ResetPassword";
import ReviewReply from "./Pages/Cortex.ReviewReply";
import SMSSettings from "./Pages/Cortex.SMSSettings";
import Security from "./Pages/Cortex.Security";
import ShowInventory from "./Pages/Cortex.ShowInventory";
import SizeDescriptions from "./Pages/Cortex.SizeDescriptions";
import SizeVisuals from "./Pages/Cortex.SizeVisuals";
import SpotReferrals from "./Pages/spot/Cortex.SpotReferrals";
import StandardCeilingHeight from "./Pages/Cortex.StandardCeilingHeight";
import StorableItems from "./Pages/Cortex.StorableItems";
import Test from "./Pages/Cortex.Subpage.Test";
import Theft from "./Pages/Cortex.Theft";
import Tour from "./Pages/Cortex.Tour";
import UnitNumber from "./Pages/Cortex.UnitNumber";
import UnitSize from "./Pages/Cortex.UnitSize";
import UnitTransfer from "./Pages/Cortex.UnitTransfer";
import UpdateBillingInformation from "./Pages/Cortex.UpdateBillingInformation";
import UpdateContactInformation from "./Pages/Cortex.UpdateContactInformation";
import VehicleStorage from "./Pages/Cortex.VehicleStorage";
import VehicleStorageCovered from "./Pages/Cortex.VehicleStorageCovered";
import VehicleStorageGuidelines from "./Pages/Cortex.VehicleStorageGuidelines";
import VehicleStorageIndoor from "./Pages/Cortex.VehicleStorageIndoor";
import VoiceAccountBalance from "./Pages/Cortex.VoiceAccountBalance";
import VoiceAccountNumber from "./Pages/Cortex.VoiceAccountNumber";
import VoiceAutopay from "./Pages/Cortex.VoiceAutopay";
import VoiceCancel from "./Pages/Cortex.VoiceCancel";
import VoiceEditAccountInfo from "./Pages/Cortex.VoiceEditAccountInfo";
import VoiceGateCode from "./Pages/Cortex.VoiceGateCode";
import VoiceGetLease from "./Pages/Cortex.VoiceGetLease";
import VoiceLoginIssues from "./Pages/Cortex.VoiceLoginIssues";
import VoiceManageInsurance from "./Pages/Cortex.VoiceManageInsurance";
import VoicePayBill from "./Pages/Cortex.VoicePayBill";
import VoicePaymentHistory from "./Pages/Cortex.VoicePaymentHistory";
import VoiceRentAUnit from "./Pages/Cortex.VoiceRentAUnit";
import VoiceSettings from "./Pages/Cortex.VoiceSettings";
import WebIssue from "./Pages/Cortex.WebIssue";
import WebRates from "./Pages/Cortex.WebRates";
import WineStorage from "./Pages/Cortex.WineStorage";
import WorkInUnit from "./Pages/Cortex.WorkInUnit";
import SequencesAbandonedCart from "./Pages/Sequences/Cortex.SequencesAbandonedCart";
import SequencesPastDue from "./Pages/Sequences/Cortex.SequencesPastDue";
import SequencesMoveIn from "./Pages/Sequences/Cortex.SequencesMoveIn";
import SequencesMoveOut from "./Pages/Sequences/Cortex.SequencesMoveOut";
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE, IF_ALL, IF_ANY } from '../../Components/Worksheets/Types/Worksheet.Interface';
import MobileApp from "./Pages/Cortex.MobileApp";
import SpotReview from "./Pages/spot/Cortex.SpotReview";
import GoogleReviewReceipts from "./Pages/Cortex.GoogleReviewReceipts";

const All: RouterWorksheetData[] = [
  {
    to: `getting-started`,
    label: "Getting Started",
    // hideIf: IS_NOT_EQUAL(LocationVarKey.LLMAccountBillingDispute, "1"), // This is how you hide shize
    children: [
      // { to: `test`, label: "Test", element: <Test /> },
      // { to: `kickoff`, label: "Kickoff / Homework", element: <GetStarted /> },
      { to: `ai-enhance`, label: "Enhance with AI", element: <Assistantllm /> },
      // { to: `ai-prompts`, label: "LLM Prompts", element: <Assistantllmprompts /> },
    ],
  },
  {
    to: `access`,
    label: "Access",
    children: [
      { to: `after-hours`, label: "After Hours Access", hideIf: IS_NOT_EQUAL(LocationVarKey.HasAfterHoursAccess, "1"), element: <AfterHourAccess /> },
      { to: `gate-code`, label: "Gate Code", element: <GateCode /> },
      { to: `key-access`, label: "Key Access", element: <KeyAccess /> },
      { to: `padlock-access`, label: "Padlock / DaVinci Access", hideIf: IS_NOT_EQUAL(LocationVarKey.HasPadlocks, "1"), element: <PadlockAccess /> },
      { to: `tour`, label: "Tour", element: <Tour /> },
      { to: `unit-number`, label: "Unit Number", element: <UnitNumber /> },
    ],
  },
  {
    to: `account-management`,
    label: "Account Management",
    children: [
      { to: `auto-pay`, label: "Autopay", element: <AutoPay /> },
      { to: `account-status`, label: "Account Status", element: <AccountStatus /> },
      { to: `account-balance`, label: "Account Balance", element: <AccountBalance /> },
      { to: `account-number`, label: "Account Number", hideIf: IS_NOT_EQUAL(LocationVarKey.WhichFMS, "StorEdge"), element: <AccountNumber /> },
      { to: `billing-dispute`, label: "Billing Dispute", element: <AccountBillingDispute /> },
      { to: `cancel-service`, label: "Cancel Service", element: <CancelService /> },
      { to: `create-login`, label: "Create Login", element: <CreateLogin /> },
      { to: `due-date`, label: "Due Date", element: <ChangeDueDate /> },
      { to: `forgot-username`, label: "Forgot Username", element: <ForgotUsername /> },
      { to: `grace-period`, label: "Grace Period", element: <GracePeriod /> },
      { to: `hold-unit`, label: "Hold Unit", element: <HoldUnit /> },
      { to: `manage-insurance`, label: "Manage Insurance", element: <ManageInsurance /> },
      { to: `multiple-accounts`, label: "Multiple Accounts", element: <MultipleAccounts /> },
      { to: `partial-payment`, label: "Partial Payment", element: <PartialPayment /> },
      { to: `past-due`, label: "Past Due", element: <PastDue /> },
      { to: `pay-bill`, label: "Pay Bill", element: <PayBill /> },
      { to: `payment-extension`, label: "Payment Extension", element: <PaymentExtension /> },
      { to: `payment-history`, label: "Payment History", element: <PaymentHistory /> },
      { to: `reservation`, label: "Reservation", element: <Reservation /> },
      { to: `reset-password`, label: "Reset Password", element: <ResetPassword /> },
      { to: `unit-size`, label: "Unit Size", element: <UnitSize /> },
      { to: `update-billing`, label: "Update Billing Info", element: <UpdateBillingInformation /> },
      { to: `update-contact-info`, label: "Update Contact Info", element: <UpdateContactInformation /> },
    ],
  },
  {
    to: `customer-profile`,
    label: "Customer Profile",
    children: [
      { to: `escalation-bot`, label: "Bot Escalation", element: <ProfileEscalationBot /> },
      { to: `cancel`, label: "Cancel", element: <ProfileCancel /> },
      { to: `escalation-customer`, label: "Customer Escalation", hideIf: IS_NOT_EQUAL(LocationVarKey.WantsCustomerInitiatedEscalations, "1"), element: <ProfileEscalationCustomer /> },
      { to: `lead-settings`, label: "Leads", element: <LeadSettings /> },
      { to: `shopping`, label: "Shopping", element: <ProfileShopping /> },
      { to: `waitlist`, label: "Waitlist", element: <ProfileWaitlist /> },
      { to: `welcome`, label: "Welcome", element: <ProfileWelcome /> },
      { to: `welcome-back`, label: "Welcome Back", element: <ProfileWelcomeBack /> },
      { to: `what-else`, label: "What Else", element: <ProfileWhatElse /> },
    ],
  },
  {
    to: `engagement`,
    label: "Engagement",
    hideIf: IF_ALL([IS_NOT_EQUAL(LocationVarKey.HasCustomCTAMessage, "1"), IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1"), IS_NOT_EQUAL(LocationVarKey.HasGoogleReviewIntegration, "1")]),
    children: [
      { to: `custom-call-to-action`, label: "Call to Action", hideIf: IS_NOT_EQUAL(LocationVarKey.HasCustomCTAMessage, "1"), element: <CTAMessage /> },
      { to: `quickreplies-livechat`, label: "Quick Replies (Live Chat)", hideIf: IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1"), element: <AgentQuickReply /> },
      { to: `quickreplies-reviews`, label: "Quick Replies (Reviews)", hideIf: IS_NOT_EQUAL(LocationVarKey.HasGoogleReviewIntegration, "1"), element: <ReviewReply /> },
      { to: `google-review-receipts`, label: "Google Review Receipts", hideIf: IS_NOT_EQUAL(LocationVarKey.HasGoogleReviewIntegration, "1"), element: <GoogleReviewReceipts /> },
    ],
  },
  {
    to: `escalations`,
    label: "Escalations",
    children: [{ to: `escalations`, label: "Escalations", element: <EscalationSettings /> }],
  },
  {
    to: `features-amenities`,
    label: "Features & Amenities",
    children: [
      { to: `auctions`, label: "Auctions", hideIf: IS_NOT_EQUAL(LocationVarKey.HasAuctions, "1"), element: <Auction /> },
      { to: `careers`, label: "Careers", hideIf: IS_NOT_EQUAL(LocationVarKey.HasCareerURL, "1"), element: <Careers /> },
      { to: `climate-control`, label: "Climate Control", hideIf: IS_NOT_EQUAL(LocationVarKey.HasClimateControlledUnits, "1"), element: <ClimateControl /> },
      { to: `dollies`, label: "Dollies", hideIf: IS_NOT_EQUAL(LocationVarKey.HasDollies, "1"), element: <Dollies /> },
      { to: `driveup-units`, label: "Drive-Up Units", hideIf: IS_NOT_EQUAL(LocationVarKey.HasDriveUpUnits, "1"), element: <DriveUp /> },
      { to: `franchise`, label: "Franchise", hideIf: IS_NOT_EQUAL(LocationVarKey.HasFranchise, "1"), element: <Franchise /> },
      { to: `lights`, label: "Lights", element: <Lights /> },
      { to: `maintenance`, label: "Maintenance/Pests", element: <MaintenancePest /> },
      { to: `mobile-app`, label: "Mobile App", hideIf: IS_NOT_EQUAL(LocationVarKey.HasMobileApp, "1"), element: <MobileApp /> },
      { to: `moving-services`, label: "Moving Services", hideIf: IS_NOT_EQUAL(LocationVarKey.HasMovingServices, "1"), element: <MovingServices /> },
      { to: `moving-truck`, label: "Moving Truck", hideIf: IS_NOT_EQUAL(LocationVarKey.HasMovingTrucks, "1"), element: <MovingTruck /> },
      { to: `packing-supplies`, label: "Packing Supplies", hideIf: IS_NOT_EQUAL(LocationVarKey.HasPackingSupplies, "1"), element: <PackingSupplies /> },
      { to: `security`, label: "Security", element: <Security /> },
      { to: `wine`, label: "Wine", hideIf: IS_NOT_EQUAL(LocationVarKey.HasWineStorage, "1"), element: <WineStorage /> },
    ],
  },
  {
    to: `issue-resolution`,
    label: "Issue Resolution",
    children: [
      { to: `billing-issue`, label: "Billing Issue", element: <BillingDispute /> },
      { to: `damaged-items`, label: "Damaged Items", element: <DamagedItems /> },
      { to: `emergency`, label: "Emergency", element: <Emergency /> },
      { to: `get-out`, label: "Get Out", element: <GetOut /> },
      { to: `lost-key`, label: "Lost Key", element: <LostKey /> },
      { to: `payment-issue`, label: "Payment Issue", element: <PaymentIssue /> },
      { to: `theft`, label: "Theft", element: <Theft /> },
      { to: `web-issues`, label: "Web Issues", element: <WebIssue /> },
    ],
  },
  {
    to: `lease`,
    label: "Lease",
    children: [
      { to: `cancellation`, label: "Cancellation", element: <Cancellation /> },
      { to: `contract-lengths`, label: "Contract Lengths", element: <ContractLengths /> },
      { to: `covid`, label: "Covid", element: <Covid /> },
      { to: `cut-locks`, label: "Cut Locks", element: <CutLocks /> },
      { to: `facility-access`, label: "Facility Access", element: <FacilityAccess /> },
      { to: `file-claim`, label: "File A Claim", element: <Claim /> },
      { to: `get-lease`, label: "Get Lease", element: <GetLease /> },
      { to: `identification`, label: "Identification", element: <Identification /> },
      { to: `insurance`, label: "Insurance", element: <Insurance /> },
      { to: `live-in-unit`, label: "Live In Unit", element: <LiveInUnit /> },
      { to: `monthly-pricing`, label: "Monthly Pricing", element: <MonthlyPayments /> },
      { to: `moveout-policy`, label: "Move Out Policy", element: <MoveOutPolicy /> },
      { to: `overlock`, label: "Overlock", element: <Overlock /> },
      { to: `pay-online`, label: "Pay Online", element: <PayOnline /> },
      { to: `payment-options`, label: "Payment Options", element: <PaymentOptions /> },
      { to: `pricing`, label: "Pricing", element: <Pricing /> },
      { to: `prorate`, label: "Prorate", element: <Prorate /> },
      { to: `refunds`, label: "Refunds", element: <Refunds /> },
      { to: `storable-items`, label: "Storable Items", element: <StorableItems /> },
      { to: `unit-transfer`, label: "Unit Transfer", element: <UnitTransfer /> },
      { to: `work-inUnit`, label: "Work In Unit", element: <WorkInUnit /> },
    ],
  },
  {
    to: `parking-vehicles`,
    label: "Parking & Vehicles",
    hideIf: IF_ALL([IS_NOT_EQUAL(LocationVarKey.HasBoatStorage, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasRVParkingCovered, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasRVParkingEnclosed, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasCoveredVehicleStorage, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasIndoorVehicleStorage, "1"),
    IS_NOT_EQUAL(LocationVarKey.HasOutdoorVehicleStorage, "1")
    ]),
    children: [
      { to: `boat`, label: "Boat Storage", hideIf: IS_NOT_EQUAL(LocationVarKey.HasBoatStorage, "1"), element: <BoatStorage /> },

      { to: `rv`, label: "RV Parking (General)", hideIf: IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"), element: <RVParking /> },
      { to: `rv-covered`, label: "RV Parking Covered", hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"), IS_NOT_EQUAL(LocationVarKey.HasRVParkingCovered, "1")]), element: <RVParkingCovered /> },
      { to: `rv-enclosed`, label: "RV Parking Enclosed", hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"), IS_NOT_EQUAL(LocationVarKey.HasRVParkingEnclosed, "1")]), element: <RVParkingEnclosed /> },

      { to: `vehicle-guidelines`, label: "Storage Guidelines", hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), element: <VehicleStorageGuidelines /> },
      { to: `vehicle-storage`, label: "Vehicle Storage (General)", hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), element: <VehicleStorage /> },
      { to: `covered`, label: "Vehicle Storage Covered", hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), IS_NOT_EQUAL(LocationVarKey.HasCoveredVehicleStorage, "1")]), element: <VehicleStorageCovered /> },
      { to: `indoor`, label: "Vehicle Storage Indoor", hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), IS_NOT_EQUAL(LocationVarKey.HasIndoorVehicleStorage, "1")]), element: <VehicleStorageIndoor /> },
      { to: `outdoor`, label: "Vehicle Storage Outdoor", hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), IS_NOT_EQUAL(LocationVarKey.HasOutdoorVehicleStorage, "1")]), element: <OutdoorParking /> },
    ],
  },
  {
    to: `pricing`,
    label: "Pricing",
    children: [
      { to: `admin-fee`, label: "Admin Fee", element: <AdminFee /> },
      { to: `credit-card-fee`, label: "Credit Card Fee", element: <CreditCardFee /> },
      { to: `discounts`, label: "Discounts", element: <Discounts /> },
      { to: `insurance-cost`, label: "Insurance Cost", element: <InsuranceCost /> },
      { to: `inventory`, label: "Show Inventory", element: <ShowInventory /> },
      { to: `late-fee`, label: "Late Fee", element: <LateFee /> },
      { to: `rate-increase`, label: "Rate Increase", element: <RateIncrease /> },
      { to: `referral`, label: "Referral", element: <Referral /> },
      { to: `web-rates`, label: "Web Rates", element: <WebRates /> },
    ],
  },
  {
    to: `sequences`,
    label: "Sequences",
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasFMSPlus, "1"),
    children: [
      { to: `move-ins`, label: "Move Ins", element: <SequencesMoveIn /> },
      { to: `pastdue`, label: "Past Due Payments", element: <SequencesPastDue /> },
      { to: `move-outs`, label: "Move Outs", element: <SequencesMoveOut /> },
      { to: `abandoned-cart`, label: "Abandoned Carts", element: <SequencesAbandonedCart /> },

      { to: `review-solicitation`, label: "Review Solicitation", element: <CronReviewSolicitations /> },
      { to: `sms-settings`, label: "SMS Settings", element: <SMSSettings /> },
    ],
  },
  {
    to: "spot",
    label: "spot",
    children: [
      { to: "referral", label: "Referral", element: <SpotReferrals /> },
      { to: "review", label: "Review", element: <SpotReview /> },
    ]
  },
  {
    to: `sizing`,
    label: "Sizing",
    children: [
      { to: `ceiling-height`, label: "Ceiling Height", element: <StandardCeilingHeight /> },
      { to: `descriptions`, label: "Size Descriptions", element: <SizeDescriptions /> },
      { to: `visuals`, label: "Size Visuals", element: <SizeVisuals /> },
    ],
  },
  {
    to: `voice`,
    label: "Voice",
    hideIf: IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1"),
    children: [
      { to: `voice-settings`, label: "Voice Settings", element: <VoiceSettings /> },
      { to: "voice-account-balance", label: "Account Balance", element: <VoiceAccountBalance /> },
      { to: "voice-account-number", label: "Account Number", hideIf: IS_NOT_EQUAL(LocationVarKey.WhichFMS, "StorEdge"), element: <VoiceAccountNumber /> },
      { to: "voice-autopay", label: "Autopay", element: <VoiceAutopay /> },
      { to: `voice-cancel`, label: "Cancel", element: <VoiceCancel /> },
      { to: `voice-gate-code`, label: "Gate Code", element: <VoiceGateCode /> },
      { to: `voice-get-lease`, label: "Get Lease", element: <VoiceGetLease /> },
      { to: `voice-login-issues`, label: "Login Issues", element: <VoiceLoginIssues /> },
      { to: "voice-manage-insurance", label: "Manage Insurance", element: <VoiceManageInsurance /> },
      { to: "voice-payment-history", label: "Payment History", element: <VoicePaymentHistory /> },
      { to: `voice-pay-bill`, label: "Pay Bill", element: <VoicePayBill /> },
      { to: `voice-rent-a-unit`, label: "Rent a Unit", element: <VoiceRentAUnit /> },
      { to: `voice-edit-account-info`, label: "Update Account Info", element: <VoiceEditAccountInfo /> },
    ],
  },
];

export const CortexWorksheetsData = {
  [LocationScope.ORG]: All,
  [LocationScope.GROUP]: All,
  [LocationScope.LOCATION]: All,
};
